/* eslint-disable @nx/enforce-module-boundaries */
'use-client';
import {
  Flex,
  Heading,
  useDisclosure,
  Spinner,
  Box,
  HStack,
  Stack,
  Switch,
  VStack,
} from '@mybridge/ui';
import { Button } from '@mybridge/ui/button';
import _ from 'lodash';
import { Text } from '@mybridge/ui/text';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { useRouter } from 'next/router';
import { useToast } from '@mybridge/ui';
import { isMobile } from 'react-device-detect';
import {
  EarthGlobeIcon,
  TeamIcon,
  OnlyMeLockIcon,
  BackArrow,
  ArrowRight,
} from '@mybridge/icons';
import {
  setAccountPermissions,
  getUserProfileInfo,
} from 'v4/store/actions/user-profile.actions';
import { SettingAccountIcon } from '@mybridge/icons/SettingAccountIcon';
import { SubscriptionBillingIcon } from '@mybridge/icons/SubscriptionBillingIcon';

import { BillingIcon } from '@mybridge/icons/BillingIcon';
import { BillingHistoryIcon } from '@mybridge/icons/BillingHistoryIcon';

import { MentionTag } from '@mybridge/icons/MentionTag';
import { PrivacyTermIcon } from '../../../../mybridgeicons/src/PrivacyTermIcon';
import { PrivacyAboutIcon } from '../../../../mybridgeicons/src/PrivacyAboutIcon';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export default function PrivacyAndTerm({
  setSelectedComponent,
  selectedComponent,
}) {
  const dispatch = useDispatch();
  const router = useRouter();
  const toast = useToast();
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const [modalOpen, setModalOpen] = useState(false);
  const [heading, setHeading] = useState(null);
  const [googleLinked, setGoogleLinked] = useState(false);
  const userFriendsPermDisc = useDisclosure();
  const userFriendsListPermDisc = useDisclosure();
  const { t } = useTranslator();

  return (
    <AuthenticatedProviders>
      <VStack gap="10px" padding="30px 16px 10px 16px">
        <Box>
          <Heading
            as="h4"
            size="md"
            p={'10px'}
            sx={{
              '@media screen and (max-width: 375px)': {
                width: '350px',
              },
              '@media screen and (max-width: 280px)': {
                padding: '6px',
              },
            }}
            border="1px solid #ECECEC"
            borderRadius="30px"
            onClick={() => {
              setSelectedComponent('privacy-policy-term');
            }}
          >
            <HStack justifyContent="start">
              <PrivacyTermIcon />
              <HStack justifyContent="space-between" width="80">
                <Text
                  fontWeight="400"
                  fontSize="16px"
                  lineHeight="19.2px"
                  color="#868585"
                  marginLeft="5%"
                  sx={{
                    '@media screen and (max-width: 375px)': {
                      fontSize: '14px',
                    },
                    '@media screen and (max-width: 280px)': {
                      fontSize: '10px',
                    },
                  }}
                >
                  {t('TnC.privacyPolicy') || "Privacy Policy"}
                </Text>
                <ArrowRight />
              </HStack>
            </HStack>
          </Heading>
        </Box>
        <Box>
          <Heading
            as="h4"
            size="md"
            p={'10px'}
            sx={{
              '@media screen and (max-width: 375px)': {
                width: '350px',
              },
              '@media screen and (max-width: 280px)': {
                padding: '6px',
              },
            }}
            border="1px solid #ECECEC"
            borderRadius="30px"
            onClick={() => {
              setSelectedComponent('privacy-policy-about');
            }}
          >
            <HStack justifyContent="start">
            <SubscriptionBillingIcon />
              <HStack justifyContent="space-between" width="80">
                <Text
                  fontWeight="400"
                  fontSize="16px"
                  lineHeight="19.2px"
                  color="#868585"
                  marginLeft="5%"
                  sx={{
                    '@media screen and (max-width: 375px)': {
                      fontSize: '14px',
                    },
                    '@media screen and (max-width: 280px)': {
                      fontSize: '10px',
                    },
                  }}
                >
                {t('otherModules.about_us') || "About us"}
                </Text>
                <ArrowRight />
              </HStack>
            </HStack>
          </Heading>
        </Box>
        <Box>
          <Heading
            as="h4"
            size="md"
            p={'10px'}
            sx={{
              '@media screen and (max-width: 375px)': {
                width: '350px',
              },
              '@media screen and (max-width: 280px)': {
                padding: '6px',
              },
            }}
            border="1px solid #ECECEC"
            borderRadius="30px"
            onClick={() => {
              setSelectedComponent('privacy-policy-term-condition');
            }}
          >
            <HStack justifyContent="start">
            <PrivacyAboutIcon />
              
              <HStack justifyContent="space-between" width="80">
                <Text
                  fontWeight="400"
                  fontSize="16px"
                  lineHeight="19.2px"
                  color="#868585"
                  marginLeft="5%"
                  sx={{
                    '@media screen and (max-width: 375px)': {
                      fontSize: '14px',
                    },
                    '@media screen and (max-width: 280px)': {
                      fontSize: '10px',
                    },
                  }}
                >
                {t('otherModules.terms_and_conditions') || "Term and Conditions"}
                </Text>
                <ArrowRight />
              </HStack>
            </HStack>
          </Heading>
        </Box>
      </VStack>
    </AuthenticatedProviders>
  );
}
